import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, BOOKING_URL } from "@/data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname, setOpen]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [setScrolled]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-black/5" : "bg-white/60 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="container-cc h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 flex items-center justify-center bg-[#A60201] text-white font-serif-display text-lg">C</span>
          <span className="font-serif-display text-[22px] tracking-tight">CraftCulture</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.slice(1, -1).map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${isActive ? "text-[#A60201]" : "text-[#0A0A0A] hover:text-[#A60201]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact" data-testid="nav-contact-link" className="text-sm font-medium hover:text-[#A60201]">Contact</Link>
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" data-testid="nav-book-call-btn" className="btn-primary text-xs">
            Book Discovery Call <ArrowUpRight size={14} />
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-black/5">
          <div className="container-cc py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive ? "text-[#A60201]" : "text-[#0A0A0A]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary mt-2 self-start" data-testid="mobile-book-call-btn">
              Book Discovery Call <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
